<template>
  <div>
    <b-row style="margin-top: 5px;">
      <b-col
        lg="12"
      >
        <div id="app">
          <div
            class="data-row"
          >
            <div class="data-label">
              <b-img
                :src="require('@/assets/images/icons/peak.svg')"
                style="height: 20px; width: 20px; margin-top: 3px; margin-right: 5px;"
              />&nbsp;
              <span style="font-size: 17px">
                Peak Hour Factor
              </span>&nbsp;
              <feather-icon
                id="popover-phf"
                icon="AlertCircleIcon"
                size="22"
                stroke="#F9A600"
              />
              <b-popover
                target="popover-phf"
                triggers="focus"
                placement="left"
              >
                <b-img
                  src="@/assets/images/formula/phf.jpeg"
                  fluid
                />
              </b-popover>
            </div>
            <div class="data-value">
              <span
                class="ml-1"
                style="margin-right: 20px; font-weight: 400; font-size:20px; color: #46E0E5; text-shadow: 0 0 4px rgba(255, 255, 255, 0.8), 0 0 20px rgba(13, 110, 253, 0.5)"
              >
                {{ PHF }}
              </span>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="12">
        <div id="app">
          <div
            class="data-row"
          >
            <div class="data-label">
              <b-img
                :src="require('@/assets/images/icons/lanedens.svg')"
                style="height: 20px; width: 20px; margin-top: 3px; margin-right: 5px;"
              />&nbsp;
              <span style="font-size: 17px">
                Lane Density
              </span>&nbsp;
              <feather-icon
                id="density"
                icon="AlertCircleIcon"
                size="22"
                stroke="#F9A600"
              />
              <b-popover
                target="density"
                triggers="focus"
              >
                <b-img
                  src="@/assets/images/formula/lane.jpeg"
                  width="250"
                />
              </b-popover>
            </div>
            <div class="data-value">
              <span
                class="ml-1"
                style="margin-right: 20px; font-weight: 400; font-size:20px; color: #46E0E5; text-shadow: 0 0 4px rgba(255, 255, 255, 0.8), 0 0 20px rgba(13, 110, 253, 0.5)"
              >
                {{ DensityLane_Total_Avg }}
              </span>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="12">
        <div id="app">
          <div
            class="data-row"
          >
            <div class="data-label">
              <b-img
                :src="require('@/assets/images/icons/freeflow.svg')"
                style="height: 20px; width: 20px; margin-top: 3px; margin-right: 5px;"
              />&nbsp;
              <span style="font-size: 17px">
                Free Flow Speed
              </span>&nbsp;
              <feather-icon
                id="ffs"
                icon="AlertCircleIcon"
                size="22"
                stroke="#F9A600"
              />
              <b-popover
                target="ffs"
                triggers="focus"
                placement="left"
              >
                <b-img
                  src="@/assets/images/formula/ffs.jpeg"
                  fluid
                />
              </b-popover>
            </div>
            <div class="data-value">
              <span
                class="ml-1"
                style="margin-right: 20px; font-weight: 400; font-size:20px; color: #46E0E5; text-shadow: 0 0 4px rgba(255, 255, 255, 0.8), 0 0 20px rgba(13, 110, 253, 0.5)"
              >
                {{ FreeFlowSpeed }}
              </span>
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="12">
        <div id="app">
          <div
            class="data-row"
          >
            <div class="data-label">
              <b-img
                :src="require('@/assets/images/icons/maxspeed.svg')"
                style="height: 20px; width: 20px; margin-top: 3px; margin-right: 5px;"
              />
              <span style="font-size: 17px">
                Max Speed
              </span>
              <a class="large-dropdown">
                <b-button
                  id="min"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="flat-warning"
                  style="font-size: 16px; text-decoration: underline;"
                >Min</b-button></a>
              <b-popover
                target="min"
                triggers="focus"
                placement="left"
              >
                <div>
                  <h4>Min Speed</h4>
                  <span style="font-size: 20px;"> {{ Speed_Min }} </span>
                  <span style="font-size: 20px;">กม./ชม.</span>
                </div>
              </b-popover>
            </div>
            <div class="data-value">
              <span
                class="ml-1"
                style="margin-right: 20px; font-weight: 400; font-size:20px; color: #46E0E5; text-shadow: 0 0 4px rgba(255, 255, 255, 0.8), 0 0 20px rgba(13, 110, 253, 0.5)"
              >
                {{ Speed_Max }}
              </span>
              กม./ชม.
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="12">
        <div id="app">
          <div
            class="data-row"
          >
            <div class="data-label">
              <b-img
                :src="require('@/assets/images/icons/85per.svg')"
                style="height: 20px; width: 20px; margin-top: 3px; margin-right: 5px;"
              />&nbsp;
              <span style="font-size: 17px">
                Average Annual Daily Traffic (AADT)
              </span>&nbsp;
              <feather-icon
                id="popover-AADT"
                icon="AlertCircleIcon"
                size="22"
                stroke="#F9A600"
              />
              <b-popover
                target="popover-AADT"
                triggers="focus"
                placement="left"
              >
                <b-img
                  src="@/assets/images/formula/aadt.jpeg"
                  fluid
                />
              </b-popover>
            </div>
            <div class="data-value">
              <span
                class="ml-1"
                style="margin-right: 20px; font-weight: 400; font-size:20px; color: #46E0E5; text-shadow: 0 0 4px rgba(255, 255, 255, 0.8), 0 0 20px rgba(13, 110, 253, 0.5)"
              >
                {{ aadt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
              </span>
              คัน/วัน
            </div>
          </div>
        </div>
      </b-col>
      <b-col lg="12">
        <div id="app">
          <div
            class="data-row"
          >
            <div class="data-label">
              <b-img
                :src="require('@/assets/images/icons/85per.svg')"
                style="height: 20px; width: 20px; margin-top: 3px; margin-right: 5px;"
              />&nbsp;
              <span style="font-size: 17px">
                Vehicle Kilometer Travel (VKT)
              </span>&nbsp;
              <feather-icon
                id="popover-VKT"
                icon="AlertCircleIcon"
                size="22"
                stroke="#F9A600"
              />
              <b-popover
                target="popover-VKT"
                triggers="focus"
                placement="left"
              >
                <b-img
                  src="@/assets/images/formula/vkt.jpeg"
                  fluid
                />
              </b-popover>
            </div>
            <div class="data-value">
              <span
                class="ml-1"
                style="margin-right: 20px; font-weight: 400; font-size:20px; color: #46E0E5; text-shadow: 0 0 4px rgba(255, 255, 255, 0.8), 0 0 20px rgba(13, 110, 253, 0.5)"
              >
                {{ vkt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
              </span>
              คัน X กม.
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div
      id="total-sales"
      style="margin-right: 90px; margin-top: -590px;"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BImg, BPopover, BButton,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BPopover,
    BButton,
  },
  data() {
    return {
      title: {
        text: '',
        subtext: 'เหตุการณ์ทั้งหมด',
        left: 'center',
        top: 'center',
        textStyle: {
          fontSize: 35,
          color: 'white',
        },
        subtextStyle: {
          fontSize: 20,
          color: 'white',
        },
      },
      series: [
        {
          color: ['#0D6EFD', '#FC6359', '#F0DE97', '#F8841A', '#29C67B', '#58A8FD'],
          name: 'เหตุการณ์',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            fontSize: '14',
            formatter: '{c} ',
            position: 'inside',
            fontWeight: 'bold',
          },
          padAngle: 5,
          labelLine: {
            show: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
          data: [
            {
              value: '', name: 'จราจรหยุดนิ่ง และจราจรล่าช้า',
            },
            {
              value: '', name: 'รถจอดในที่ห้ามจอด',
            },
            {
              value: '', name: 'การปิดกั้นทาง',
            },
            {
              value: '', name: 'งานก่อสร้างทาง',
            },
            {
              value: '', name: 'รถจอดเสีย',
            },
            {
              value: '', name: 'รถเกิดอุบัติเหตุ',
            },
          ],
        },
      ],
      date: {
        typeDropdown: 'daily',
        direction: 'ทั้งหมด',
        dateFrom: '',
        dateTo: '',
        month: new Date().getFullYear(),
        year: 1,
      },
      itemsIncident: [
        {
          label: 'จราจรล่าช้า และหยุดนิ่ง', percentage: 36, value: 18720, icon: 'standstill.png', color: '#0D6EFD',
        },
        {
          label: 'รถจอดพื้นที่ห้าม', percentage: 36, value: 18720, icon: 'no_parking.png', color: '#FC6359',
        },
        {
          label: 'การปิดกั้นทาง', percentage: 36, value: 18720, icon: 'blocking_road.png', color: '#C19C54',
        },
        {
          label: 'งานก่อสร้างทาง', percentage: 36, value: 18720, icon: 'road_construction.png', color: '#F8841A',
        },
        {
          label: 'รถจอดเสีย', percentage: 36, value: 18720, icon: 'broke_down.png', color: '#29C67B',
        },
        {
          label: 'รถเกิดอุบัติเหตุ', percentage: 36, value: 18720, icon: 'accident.png', color: '#58A8FD',
        },
      ],
      startMonth: 2020,
      endMonth: new Date().getFullYear(),
      startYear: 1,
      endYear: 5,
      userData: JSON.parse(localStorage.getItem('userData')),
      optionDirection: ['ทั้งหมด', 'ขาเข้า', 'ขาออก'],
      optionTime: [{ label: 'รายวัน', value: 'daily' }, { label: 'รายเดือน', value: 'monthly' }, { label: 'รายปี', value: 'yearly' }],
      PHF: 0,
      FreeFlowSpeed: 0,
      DensityLane_Total_Avg: 0,
      Speed_Max: 0,
      vkt: 0,
      aadt: 0,
      formula: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    monthList() {
      const years = []
      // eslint-disable-next-line no-plusplus
      for (let i = this.endMonth; i >= this.startMonth; i--) {
        years.push(i)
      }
      return years
    },
    yearList() {
      const years = []
      // eslint-disable-next-line no-plusplus
      for (let i = this.endYear; i >= this.startYear; i--) {
        years.push(i)
      }
      return years
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.interval = setInterval(() => {
      this.getFormula()
      this.getSumCount()
    }, 300000)
  },
  mounted() {
    this.setToday()
    this.getFormula()
    this.getSumCount()
  },
  methods: {
    getSumCount() {
      axios
        .post('/getSumCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.Speed_Max = response.data[0].Speed_Max.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Speed_Min = response.data[0].Speed_Min.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          this.Speed_Max_TSC = response.data[0].max_speed_limit
          this.Speed_Min_TSC = response.data[0].min_speed_lmit
        })
        .catch(error => {
          console.log(error)
        })
    },
    getFormula() {
      axios
        .post('/getFormulaCountDetail', { wid: this.$route.query.wid })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.formula = response.data[0]
          this.PHF = response.data[0].PHF
          this.FreeFlowSpeed = response.data[0].FreeFlowSpeed
          this.DensityLane_Total_Avg = response.data[0].DensityLane_Total_Avg
          this.aadt = this.formula.AADT
          this.vkt = this.formula.VKT
          console.log(this.aadt)
        })
        .catch(error => {
          console.log(error)
        })
    },
    setToday() {
      const p = new Date()
      const month = (`0${p.getMonth() + 1}`).slice(-2)
      const date = 1
      const year = p.getFullYear()
      const dateTo = (`0${p.getDate()}`).slice(-2)
      this.date.dateFrom = `${year}-${month}-${date}`
      this.date.dateTo = `${year}-${month}-${dateTo}`
    },
  },
}
</script>

<style scope lang="scss">
.style-chooser .vs__dropdown-toggle {
  border: 0px solid #000000 !important; /* Change #0000FF to the color you'd like on hover */
  background: #131313 !important;
}
.style-chooser .vs__dropdown-toggle .vs__search::placeholder {
  color: rgb(255, 255, 255);
  opacity: 1; /* ทำให้สีเห็นชัดเจนขึ้น */
}
.data-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  padding: 10px;
  border-radius: 4px;
}

.data-label {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.data-icon {
  width: 24px;
  height: 24px;
  background-size: cover;
  margin-right: 10px;
}

.data-percentage {
  display: flex;
  align-items: center;
}
.data-value{
  font-size: 16px;
}

:root {
  color-scheme: dark;
  --primary-rgb:
    0,
    255,
    190;
  --primary-color: rgb(var(--primary-rgb));
  --primary-border: rgb(var(--primary-rgb));
  --primary01: rgba(var(--primary-rgb), 0.1);
  --primary02: rgba(var(--primary-rgb), 0.2);
  --primary03: rgba(var(--primary-rgb), 0.3);
  --primary04: rgba(var(--primary-rgb), 0.4);
  --primary05: rgba(var(--primary-rgb), 0.5);
  --primary06: rgba(var(--primary-rgb), 0.6);
  --primary07: rgba(var(--primary-rgb), 0.7);
  --primary08: rgba(var(--primary-rgb), 0.8);
  --primary09: rgba(var(--primary-rgb), 0.9);
  --primary005: rgba(var(--primary-rgb), 0.05);
  --default-font-family: "Rajdhani", sans-serif;
  --default-font-weight: 400;
}
#total-sales,
#profit-per-sale {
  position: relative;
}
#total-sales .apexcharts-radialbar-hollow,
#total-sales .apexcharts-radialbar-track.apexcharts-track path,
#total-sales:before,
#profit-per-sale:before {
  width: 80px;
  height: 80px;
  content: "";
  position: absolute;
  border-radius: 50%;
  border: 2px dashed var(--primary-color);
  top: 8px;
  animation: rotate 10s linear infinite;
  inset-inline-end: 9px;
  background-color: var(--primary01);
}

.large-dropdown .dropdown-menu {
  min-width: 100px; /* Adjust width as needed */
  font-size: 12px; /* Smaller font size */
  padding: 5px; /* Smaller padding */
}
.large-dropdown .btn {
  padding: 0.25rem 0.5rem; /* Smaller button padding */
  font-size: 0.875rem; /* Smaller text on the dropdown button */
}
</style>
